"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateFormSettings = exports.UpdateFormSettingsActionType = exports.updateFormSettings = exports.loadFormSettings = exports.FetchFormSettings = exports.FetchFormSettingsActionType = exports.FormSettingsActionType = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var FormSettingsActionType = (0, _namespacedKeyMirror.default)({
  FETCH_FORM_SETTINGS: null,
  LOAD_FORM_SETTINGS: null,
  UPDATE_FORM_SETTINGS: null
}, _constants.FORM_SETTINGS);
exports.FormSettingsActionType = FormSettingsActionType;
var FetchFormSettingsActionType = (0, _actions.createRequestTypes)(FormSettingsActionType.FETCH_FORM_SETTINGS);
exports.FetchFormSettingsActionType = FetchFormSettingsActionType;
var FetchFormSettings = (0, _actions.createRequestActions)(FetchFormSettingsActionType);
exports.FetchFormSettings = FetchFormSettings;
var loadFormSettings = (0, _fluxActions.createAction)(FormSettingsActionType.LOAD_FORM_SETTINGS);
exports.loadFormSettings = loadFormSettings;
var updateFormSettings = (0, _fluxActions.createAction)(FormSettingsActionType.UPDATE_FORM_SETTINGS, (0, _actions.mapPayloadTo)('data'));
exports.updateFormSettings = updateFormSettings;
var UpdateFormSettingsActionType = (0, _actions.createRequestTypes)(FormSettingsActionType.UPDATE_FORM_SETTINGS);
exports.UpdateFormSettingsActionType = UpdateFormSettingsActionType;
var UpdateFormSettings = (0, _actions.createRequestActions)(UpdateFormSettingsActionType, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateFormSettingsActionType.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.sdk.formSettings.update.success')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateFormSettingsActionType.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('marketing.sdk.formSettings.update.failure')));
  }
});
exports.UpdateFormSettings = UpdateFormSettings;